import PropTypes from 'prop-types';
import { StyledLink, StyledCircle } from './CategoryLink.styles';

function CategoryLink({ link, color, name }) {
  if (!link || !name) return null;

  return (
    <StyledLink to={link}>
      {color && <StyledCircle color={color} />}
      <span>{name}</span>
    </StyledLink>
  );
}

CategoryLink.propTypes = {
  link: PropTypes.string,
  color: PropTypes.string,
  name: PropTypes.string,
};

CategoryLink.defaultProps = {
  name: 'Insert category name',
};

export default CategoryLink;
